module.exports = __webpack_public_path__ + "static/final-trophy-small-4be2ad90b8ed7ec1d1ccd87fc5c24e67.jpg";